// src/pages/ForgotPasswordPage.jsx
import React, { useEffect, useState } from "react";
import { api } from "../services/api";
import { Mail, BookOpen } from "lucide-react";
import { Link } from "react-router-dom";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const header = document.querySelector("header");
    const mq = window.matchMedia("(max-width: 1024px)");
    const apply = () => {
      if (!header) return;
      if (mq.matches) header.classList.add("hidden");
      else header.classList.remove("hidden");
    };
    apply();
    mq.addEventListener("change", apply);
    return () => {
      mq.removeEventListener("change", apply);
      if (header) header.classList.remove("hidden");
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    setLoading(true);
    try {
      const res = await api.post("/api/auth/forgot-password", { email });
      setMessage(res.data.message || "Check your email to reset the password.");
    } catch (err) {
      setError(err.response?.data?.detail || "Error sending email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="lg:hidden grid min-h-svh">
        <div className="flex flex-col gap-4 p-6 md:p-10">
          <div className="flex flex-1 items-center justify-center">
            <div className="flex flex-col items-center gap-6">
              <img src="/LogoBeatPost.png" alt="Beatpost" style={{ width: "93px", height: "85px" }} />
              <div className="w-full max-w-xs">
                <form onSubmit={handleSubmit} className="flex flex-col gap-6">
                  <div className="flex flex-col items-center gap-1 text-center">
                    <h1 className="text-2xl font-bold text-newspaper-900">Recuperar contraseña</h1>
                    <p className="text-sm text-newspaper-600">Introduce tu correo para recibir el enlace</p>
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-newspaper-700 mb-2">
                      Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="beat-input rounded-lg"
                      placeholder="m@example.com"
                      required
                    />
                  </div>
                  <div>
                    <button
                      type="submit"
                      disabled={loading}
                      className="w-full beat-button flex items-center justify-center space-x-2 py-3 rounded-lg"
                    >
                      {loading ? (
                        <div className="beat-spinner"></div>
                      ) : (
                        <>
                          <Mail className="w-4 h-4" />
                          <span>Enviar enlace</span>
                        </>
                      )}
                    </button>
                  </div>
                  {(message || error) && (
                    <div className="text-center">
                      {message && <p className="text-green-600 text-sm">{message}</p>}
                      {error && <p className="text-red-600 text-sm">{error}</p>}
                    </div>
                  )}
                  <p className="text-center text-newspaper-600 mt-3">
                    ¿Ya tienes cuenta?{" "}
                    <Link to="/login" className="underline underline-offset-4 text-newspaper-900">
                      Inicia sesión
                    </Link>
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hidden lg:block">
        <div className="beat-container max-w-md mx-auto">
          <div className="beat-card p-8 rounded-lg">
            <div className="text-center mb-8">
              <div className="flex justify-center items-center mb-4">
                <BookOpen className="w-12 h-12 text-newspaper-900" />
              </div>
              <h1 className="text-2xl font-bold text-newspaper-900 mb-2">Reset Password</h1>
              <p className="text-newspaper-600">Receive an email to reset your password</p>
            </div>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-newspaper-700 mb-2">
                  Email address
                </label>
                <div className="relative">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="beat-input pl-10 rounded-lg"
                    placeholder="your@email.com"
                    required
                  />
                  <Mail className="absolute left-3 top-2.5 w-4 h-4 text-newspaper-400" />
                </div>
              </div>
              <button
                type="submit"
                disabled={loading}
                className="w-full beat-button flex items-center justify-center space-x-2 py-3 rounded-lg"
              >
                {loading ? (
                  <div className="beat-spinner"></div>
                ) : (
                  <>
                    <Mail className="w-4 h-4" />
                    <span>Enviar enlace</span>
                  </>
                )}
              </button>
            </form>
            {(message || error) && (
              <div className="mt-6 text-center">
                {message && <p className="text-green-600 text-sm">{message}</p>}
                {error && <p className="text-red-600 text-sm">{error}</p>}
              </div>
            )}
            <div className="mt-6 text-center">
              <p className="text-newspaper-600">
                ¿Recordaste tu contraseña?{" "}
                <Link to="/login" className="text-newspaper-900 font-medium hover:underline">
                  Inicia sesión
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPasswordPage;
